import Option from '@/components/form/types/Option.ts';
import { TransportSelectionMode } from '@/features/dashboard/tourTransport/types/TransportSelectionMode.ts';

export const transportSelectionModeLabels: Record<
  TransportSelectionMode,
  string
> = {
  [TransportSelectionMode.MANDATORY]: 'Obowiązkowy',
  [TransportSelectionMode.OPTIONAL]: 'Opcjonalny',
};

export const getTransportSelectionModeLabel = (mode: string): string =>
  transportSelectionModeLabels[mode as TransportSelectionMode] ?? mode;

export const transportSelectionModeToggleOptions: Option[] = Object.values(
  TransportSelectionMode,
).map((value) => ({
  value,
  label: transportSelectionModeLabels[value],
}));
